import { render, staticRenderFns } from "./SidebarToggleButton.vue?vue&type=template&id=1955b630&scoped=true&"
import script from "./SidebarToggleButton.vue?vue&type=script&lang=ts&"
export * from "./SidebarToggleButton.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarToggleButton.vue?vue&type=style&index=0&id=1955b630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1955b630",
  null
  
)

export default component.exports